interface IRegex {
  mask: (string | RegExp)[];
  regEx: RegExp;
  format?: string;
}

export const phoneRegex: IRegex = {
  format: '(###) ###-####',
  mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  regEx: /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/
};

export const federalTaxIdRegex: IRegex = {
  mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  regEx: /^\d{2}\-?\d{7}$/
};

// tslint:disable-next-line:max-line-length
export const urlRegex: RegExp = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

export const formatStringToPhone = (phoneString: string | null): string => {
  if (phoneString) {
    // remove all existing non-numbers from string
    const p = phoneString.replace(/\D/g, '');

    return p ? `(${p[0]}${p[1]}${p[2]}) ${p[3]}${p[4]}${p[5]}-${p[6]}${p[7]}${p[8]}${p[9]}` : '';
  }
  return '';
};
